import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { ColorLightGray } from '../../../../shared/GlobalStyles';
import Title from './Title';

const OptedContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
`;

const Text = styled('p')`
  font-size: 14px;
  margin-bottom: 5px;
  color: ${ColorLightGray};
  opacity: 1;
`;

const OptedOut = (props) => {
  let { reason } = props;
  const { note, subExerName } = props;

  switch (reason) {
    case 'INJURY':
      reason = 'Injury';
      break;
    case 'PROHIBITED':
      reason = 'Prohibited';
      break;
    case 'LACK OF EQUIPMENT':
      reason = 'Lack of Equipment';
      break;
    case 'OTHER':
      reason = 'Other (explained below)';
      break;
    default:
  }

  return (
    <OptedContainer>
      <Title
        icon='opt-out'
        noMargin
      >
        Opted-Out
      </Title>
      <Text>
        Reason: {reason}
      </Text>
      <Text>
        Note: {note}
      </Text>
      {subExerName && (
        <Text>
          Substitute: {subExerName}
        </Text>
      )}

    </OptedContainer>
  );
};

OptedOut.propTypes = {
  note: PropTypes.string.isRequired,
  reason: PropTypes.number.isRequired,
  subExerName: PropTypes.string.isRequired,
};

export default OptedOut;
